import React, { Suspense } from 'react';

function LazyViewer(props) {
  var Viewer = React.lazy(function () {
    return import(
    /* webpackMode: "eager" */
    './Viewer');
  });
  return React.createElement(Suspense, null, React.createElement(Viewer, Object.assign({
    url: props.url,
    initialScale: 1
  }, props)));
}

export default React.memo(LazyViewer);